import { ContactSalesSM } from "../service-models/contact-sales.s-m";
import { BaseViewModel } from "./base.viewmodel";

export class ContactsalesViewModel implements BaseViewModel {
    showCompanyInfo: boolean = false;
    PageTitle: string = 'contact us';
    contacts: ContactSalesSM[] = [];
    singleContactSales: ContactSalesSM=new ContactSalesSM();
}